/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VendorRefDto } from '../models/vendor-ref-dto';
import { VendorSearchResultDto } from '../models/vendor-search-result-dto';

@Injectable({
  providedIn: 'root',
})
export class VendorService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation searchVendorsPaged
   */
  static readonly SearchVendorsPagedPath = '/vendors';

  /**
   * Search for vendors.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchVendorsPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchVendorsPaged$Response(params: {
    search?: string;
    page?: number;
    size: number;
  }): Observable<StrictHttpResponse<VendorSearchResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.SearchVendorsPagedPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VendorSearchResultDto>;
      })
    );
  }

  /**
   * Search for vendors.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchVendorsPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchVendorsPaged(params: {
    search?: string;
    page?: number;
    size: number;
  }): Observable<VendorSearchResultDto> {

    return this.searchVendorsPaged$Response(params).pipe(
      map((r: StrictHttpResponse<VendorSearchResultDto>) => r.body as VendorSearchResultDto)
    );
  }

  /**
   * Path part for operation createVendor
   */
  static readonly CreateVendorPath = '/vendors';

  /**
   * Add Vendor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createVendor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVendor$Response(params: {
    body: VendorRefDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.CreateVendorPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Add Vendor.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createVendor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createVendor(params: {
    body: VendorRefDto
  }): Observable<void> {

    return this.createVendor$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getVendorById
   */
  static readonly GetVendorByIdPath = '/vendors/{vendorId}';

  /**
   * Get Vendor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVendorById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendorById$Response(params: {
    vendorId: string;
  }): Observable<StrictHttpResponse<VendorRefDto>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.GetVendorByIdPath, 'get');
    if (params) {
      rb.path('vendorId', params.vendorId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VendorRefDto>;
      })
    );
  }

  /**
   * Get Vendor.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVendorById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendorById(params: {
    vendorId: string;
  }): Observable<VendorRefDto> {

    return this.getVendorById$Response(params).pipe(
      map((r: StrictHttpResponse<VendorRefDto>) => r.body as VendorRefDto)
    );
  }

  /**
   * Path part for operation updateVendorById
   */
  static readonly UpdateVendorByIdPath = '/vendors/{vendorId}';

  /**
   * Update Vendor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateVendorById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVendorById$Response(params: {
    vendorId: string;
    body: VendorRefDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.UpdateVendorByIdPath, 'put');
    if (params) {
      rb.path('vendorId', params.vendorId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update Vendor.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateVendorById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateVendorById(params: {
    vendorId: string;
    body: VendorRefDto
  }): Observable<void> {

    return this.updateVendorById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteVendorById
   */
  static readonly DeleteVendorByIdPath = '/vendors/{vendorId}';

  /**
   * Delete Vendor.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteVendorById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVendorById$Response(params: {
    vendorId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.DeleteVendorByIdPath, 'delete');
    if (params) {
      rb.path('vendorId', params.vendorId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete Vendor.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteVendorById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteVendorById(params: {
    vendorId: string;
  }): Observable<void> {

    return this.deleteVendorById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
